<template>
  <div>
    <div class="banner">
      <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
      <v-row dense>
        <v-col
          cols="12"
          sm="12"
          class="d-flex flex-column align-center justify-center"
        >
          <h4 class="mb-2 text-center">
            Para qual tipo de paciente é este motivo?
            <span style="color: red">*</span>
          </h4>

          <v-radio-group
            v-model="resource.kind_of_donor_id"
            row
            class="d-flex justify-center"
          >
            <v-radio label="ME" :value="1"></v-radio>
            <v-radio label="PCR" :value="2"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-text-field
            class="rounded-lg"
            color="#41916b"
            outlined
            maxlength="100"
            counter="100"
            v-model="resource.description"
            :rules="formRules"
            dense
          >
            <template v-slot:label>
              Descrição do Motivo <span style="color: red">*</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          class="rounded-lg"
          color="#e74c3c"
          text
          elevation="0"
          @click="closeDialog()"
        >
          <span>{{$t('buttons.cancel')}}</span>
        </v-btn>

        <v-btn
          class="rounded-lg"
          color="blue"
          text
          elevation="0"
          @click="$refs.form.reset()"
        >
          <span>{{$t('buttons.clean_up')}}</span>
        </v-btn>

        <v-btn
          class="rounded-lg"
          elevation="0"
          color="#41916b"
          type="submit"
          :loading="loading"
        >
          <span class="textBtn">{{ btnMessage }}</span>
          <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>
<script>
import { saveReasonFamilyRefusal } from "@/service/basic-registrations/ReasonFamilyRefusalService";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      formRules: [(v) => !!v || "Campo obrigatório."],
      loading: false,
      reason_not_donation_id: 1,
    };
  },

  props: {
    resource: {
      type: Object,
    },
  },

  computed: {
    title() {
      return this.resource.id ? 'Atualizar Motivo de Recusa' : 'Novo Motivo de Recusa';
    },

    btnMessage() {
      return this.resource.id ? 'Atualizar' : 'Salvar';
    }
  },

  watch: {
    resource: {
      handler(item) {
        if (!item) return;

        this.resource.kind_of_donor_id = Number(item.kind_of_donor_id);

        if (!item.id && this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },

      immediate: true,
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        const dados = {
          description: this.resource.description,
          kind_of_donor_id: this.resource.kind_of_donor_id,
          reason_not_donation_id: 1,
        };

        saveReasonFamilyRefusal(this.resource.id || null, dados)
          .then((response) => {
            this.loading = false;
            this.dialog = false;
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
              this.closeDialog();
            }, 3000);
          })
          .catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });
      }
    },

    closeDialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();

      this.subReasons = [{ description: "" }];

      this.$emit("closeDialog");
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #41916b, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #41916b, #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
